import { Fragment } from 'react';
import { Popover, Transition } from '@headlessui/react';
import { Link } from 'react-router-dom';
import blueGearIcon from '../images/shortcut_icons/blue_gear_icon.png';
import whiteGearIcon from '../images/shortcut_icons/white_gear_icon.png';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function MobileMyShortcuts({ data }) {
  return (
    <Popover className='relative'>
      {({ open }) => (
        <>
          <Popover.Button
            className={classNames(
              open
                ? 'border-t-4 border-gray-100 bg-white text-brandPrimary'
                : 'bg-brandPrimaryLight text-white',
              'flex h-14 w-80 flex-row items-center justify-between text-lg font-bold focus:outline-none',
            )}
          >
            <div className='flex w-full flex-row items-center justify-between duration-300 ease-in-out'>
              <div className='ml-4 flex h-8 w-8'></div>
              <div className=' flex text-base font-bold'>My Shortcuts</div>
              <div className='mr-4 h-8 w-8'>
                {/* <CogIcon className='mr-4 h-10 w-10' /> */}
                {open ? (
                  <img className='h-8 w-8' src={blueGearIcon} />
                ) : (
                  <img className='h-8 w-8' src={whiteGearIcon} />
                )}
              </div>
            </div>
          </Popover.Button>

          <Transition
            as={Fragment}
            enter='transition ease-out duration-200'
            enterFrom='opacity-0 translate-y-1'
            enterTo='opacity-100 translate-y-0'
            leave='transition ease-in duration-150'
            leaveFrom='opacity-100 translate-y-0'
            leaveTo='opacity-0 translate-y-1'
          >
            <Popover.Panel className='absolute left-1/2 z-10 w-screen max-w-xs -translate-x-1/2 transform overflow-x-hidden px-0'>
              <div className='overflow-hidden'>
                <nav className='relative overflow-hidden border-t-4 border-gray-800 border-opacity-10 bg-brandPrimary shadow-xl'>
                  {data?.map((item, itemIdx) => (
                    <Link key={itemIdx} to={item?.href}>
                      <div
                        className={`${
                          item?.current
                            ? ' bg-white text-[#0A9BBE]'
                            : ' border-b-4 border-b-gray-800 border-opacity-10 bg-[#0A9BBE] text-white'
                        } flex h-12 flex-row items-center overflow-hidden`}
                      >
                        <div>
                          <img src={item?.icon} className='ml-8 h-7 w-7' />
                        </div>
                        <div className='flex w-full flex-row justify-center text-center text-lg font-bold'>
                          {item?.name}
                        </div>
                      </div>
                    </Link>
                  ))}
                </nav>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
